import { ADD_ACTIVITY_STREAM_ITEM } from 'common/services/notifications'

interface ActivityPayload {
  id?: string
  scope?: string
}

const activityStreamTransformer = ({
  payload,
  event_key,
}: {
  payload: ActivityPayload
  event_key: string
}) => {
  const { id, scope } = payload
  return {
    payload,
    id,
    scope,
    event_key,
    created_at: new Date(),
    seen_at: null,
  }
}

interface EventMapEntry {
  eventType: string
  actionType: string
  transformData: (data: unknown, eventKey: string) => unknown
}

const eventMap: Record<string, EventMapEntry> = {
  'mood.plot': {
    eventType: 'mood.plot',
    actionType: 'NEW_MOOD_METER_PLOT',
    transformData: (data: unknown, eventKey: string) => {
      return { ...(data as Record<string, unknown>), event_key: eventKey }
    },
  },
  'school.insert': {
    eventType: 'school.insert',
    actionType: ADD_ACTIVITY_STREAM_ITEM,
    transformData: activityStreamTransformer as (data: unknown, eventKey: string) => unknown,
  },
  'district.insert': {
    eventType: 'district.insert',
    actionType: ADD_ACTIVITY_STREAM_ITEM,
    transformData: activityStreamTransformer as (data: unknown, eventKey: string) => unknown,
  },
  'staff_charter.insert': {
    eventType: 'staff_charter.insert',
    actionType: ADD_ACTIVITY_STREAM_ITEM,
    transformData: activityStreamTransformer as (data: unknown, eventKey: string) => unknown,
  },
  'staff_charter_survey.insert': {
    eventType: 'staff_charter_survey.insert',
    actionType: ADD_ACTIVITY_STREAM_ITEM,
    transformData: activityStreamTransformer as (data: unknown, eventKey: string) => unknown,
  },
  'mood_meter_group.insert': {
    eventType: 'mood_meter_group.insert',
    actionType: ADD_ACTIVITY_STREAM_ITEM,
    transformData: activityStreamTransformer as (data: unknown, eventKey: string) => unknown,
  },
  'resource.insert': {
    eventType: 'resource.insert',
    actionType: ADD_ACTIVITY_STREAM_ITEM,
    transformData: activityStreamTransformer as (data: unknown, eventKey: string) => unknown,
  },
  'course.insert': {
    eventType: 'course.insert',
    actionType: ADD_ACTIVITY_STREAM_ITEM,
    transformData: activityStreamTransformer as (data: unknown, eventKey: string) => unknown,
  },
  'message.post': {
    eventType: 'message.post',
    actionType: ADD_ACTIVITY_STREAM_ITEM,
    transformData: activityStreamTransformer as (data: unknown, eventKey: string) => unknown,
  },
  'person.insert_self_signup': {
    eventType: 'person.insert_self_signup',
    actionType: ADD_ACTIVITY_STREAM_ITEM,
    transformData: activityStreamTransformer as (data: unknown, eventKey: string) => unknown,
  },
}

export const type = (object: string, action: string): string => {
  return `${object}.${action}`
}

export const event = (object: string, action: string): EventMapEntry => {
  const key = type(object, action)
  const found = eventMap[key]
  if (!found) {
    throw new Error(`Unknown event: '${key}'`)
  }
  return found
}

export default eventMap
